import { Origin } from "@bitwarden/web-vault/app/models/types/general-types";

export type SyncedAccountFetchGateInputs = {
  fiskilConsent: boolean;
  plaidItem: boolean;
  basiqHasActiveConsent: boolean;
};

/**
 * Origin-specific predicate for enabling Fetch Data on account-details.
 * Fiskil and Plaid gates are independent — Plaid must not use Fiskil consent.
 */
export function canFetchSyncedAccountData(
  origin: Origin | undefined,
  gates: SyncedAccountFetchGateInputs,
): boolean {
  if (!origin) {
    return false;
  }

  switch (origin) {
    case Origin.fiskil:
      return gates.fiskilConsent;
    case Origin.plaid:
      return gates.plaidItem;
    case Origin.basiq:
      return gates.basiqHasActiveConsent;
    default:
      return false;
  }
}
